import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AppIcons from "AppIcons";

class PollMenu extends Component {
  onMenuClick() {
    var path = _.lowerCase(this.props.item.iconName);
    this.props.history.push(`/dashboard/polls/${path}`);
  }

  render() {
    var iconName = _.lowerCase(this.props.item.iconName);

    if (_.endsWith(iconName, "s")) {
      iconName = iconName.substr(0, iconName.length - 1);
    }

    var iconUrl = `../../style/images/poll-icons/${iconName}${
      this.props.selected ? "-Selected" : ""
    }.png`;
    return (
      <li
        className={
          this.props.selected
            ? "list-group-item content-features-li-active"
            : "list-group-item content-features-li"
        }
        onClick={this.onMenuClick.bind(this)}
      >
        {/* <img src={iconUrl} /> */}
        <div className={`sub-menu-icons`}>{AppIcons[iconName]}</div>
        <span className="sub-menu-name">{this.props.item.title}</span>
      </li>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var pathName = _.last(_.split(ownProps.location.pathname, "/"));
  return {
    selected: ownProps.item.iconName == pathName,
  };
}

export default withRouter(connect(mapStateToProps)(PollMenu));
